module.exports = __webpack_public_path__ + "static/media/16-jul31dec20.8fe74adf.pdf";